const Log = require("laravel-mix/src/Log");

document.addEventListener('DOMContentLoaded', () => {
    const cartTooltip = document.querySelector('.js-cart-tooltip')
    const cartTooltipCloseBtn = cartTooltip ? cartTooltip.querySelector('.js-close-tooltip') : null;
    const cartMobileComponent = document.querySelector('.js-cart-mobile')
    const closeCartMobileComponentBtns = document.querySelectorAll('.js-cart-mobile-close')
    const showCartMobileComponentBtns = document.querySelectorAll('.js-cart-mobile-show')
    const windowWidth = window.innerWidth
    const windowsMobile = 1024;
    const lang = document.querySelector('html').getAttribute('lang') === 'uk' ? 'ua' : document.querySelector('html').getAttribute('lang')
    let focusInputMobile = true;
    function getHeaders() {
        return {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        };
    }

    function updateCounter(counter, count) {
        if (!counter) {
            return
        }

        counter.textContent = count;
        if (count > 0) {
            counter.style.display = null;
        } else {
            counter.style.display = 'none';
        }
    }
    document.querySelectorAll('.buy-button').forEach(function (buyButton) {
        buyButton.addEventListener('click', async function() {
            if (!await Alpine.store('cartService').addToCart(this.value)) {
                return;
            }
            showCartTooltip();
            if (windowWidth > windowsMobile) {
                const cartModel = document.querySelector('.cart-moded__box');
                fadeIn(cartModel, 'flex');
                document.body.classList.add('overflow-hidden')
            }
            dataLayer.push({
                event: 'add_to_cart',
                ecommerce: {
                    items: [
                        {
                            item_name: this.dataset.title,
                            item_id: this.dataset.id,
                            price: parseFloat(this.dataset.price).toFixed(2),
                            item_brand: this.dataset.brand,
                            item_category: this.dataset.category,
                        },
                    ],
                },
            });

            fbq('track', 'AddToCart', {
                value: this.dataset.price,
                currency: 'UAH',
                content_type: 'product',
                content_ids: [this.dataset.id],
            });
        });
    });


    function openMobileCart() {
        document.body.classList.add('overflow-hidden')

        cartMobileComponent.classList.add('transform')
        cartMobileComponent.classList.add('translate-x-full')
    }

    function hideMobileCart() {
        cartMobileComponent.classList.remove('transform')
        cartMobileComponent.classList.remove('translate-x-full')
        document.body.classList.remove('overflow-hidden')
    }


    let isTooltipVisible = false;

    function showCartTooltip() {
        if (!isTooltipVisible) {
            isTooltipVisible = true;
            cartTooltip.classList.remove('-top-16');
            cartTooltip.classList.add('top-16');

            setTimeout(() => {
                hideCartTooltip();
            }, 3000);
        }
    }



    function fadeIn(el, display){
        el.style.opacity = 0;
        el.style.display = display || "block";

        (function fade() {
            var val = parseFloat(el.style.opacity);
            if (!((val += .1) > 1)) {
                el.style.opacity = val;
                requestAnimationFrame(fade);
            }
        })();
    };



    function hideCartTooltip() {
        isTooltipVisible = false
        cartTooltip.classList.add('-top-16')
        cartTooltip.classList.remove('top-16')
    }

    if(cartTooltipCloseBtn) {
        cartTooltipCloseBtn.addEventListener('click', () => {
            hideCartTooltip()
            openMobileCart()
        })
    }
    showCartMobileComponentBtns.forEach((el) => {
        el.addEventListener('click', openMobileCart)
    })
    closeCartMobileComponentBtns.forEach((el) => {
        el.addEventListener('click', hideMobileCart)
    })
})
